// Alternative pages (/alternatives/:slug). Read by the page template,
// scripts/prerender.mjs and scripts/verify-seo.mjs.
//
// Rules: describe competitors only with stable, publicly known facts; no
// prices, ratings or "better than" claims; say plainly what SEO Signals does
// not do; date the comparison and point readers to the competitor's own site.

export const COMPARED_ON = "October 2026";

const OURS = {
  job: "Turns your own Search Console and GA4 data into up to three recommended fixes",
  data: "Your Google Search Console and Google Analytics 4 properties, with read-only access",
  output: "Up to three priorities, each with the query or page and the numbers behind it",
  ga4: "Yes. Landing pages with visits but few key events can become a priority",
  questions: "Yes. Ask about your own data in plain English",
  start: "Connecting a site and viewing your first priorities is free",
};

export const ALTERNATIVES = [
  {
    slug: "semrush",
    name: "Semrush",
    site: "https://www.semrush.com",
    nav: "Semrush vs SEO Signals",
    title: "Semrush alternative for Search Console and GA4 priorities | SEO Signals",
    description: "Semrush is a full marketing suite. SEO Signals is a simpler option that reads your own Search Console and GA4 data and shows up to three fixes.",
    h1: "A simpler Semrush alternative for your own site data",
    lead: "Semrush is a large SEO and marketing suite built on its own keyword, domain and backlink databases. SEO Signals does one narrower job: it reads your Google Search Console and GA4 data and tells you which few fixes to make first.",
    theirJob: "All-in-one SEO and marketing suite",
    theirData: "Semrush's own databases of keywords, domains and backlinks, plus integrations with Google tools",
    theirOutput: "Reports and dashboards across many tools",
    theirFeatures: ["Keyword research database", "Competitor and domain research", "Backlink analysis", "Position tracking", "Site audit crawler"],
    chooseThem: ["You research keywords and competitors you don't rank for yet.", "You need backlink analysis or daily position tracking.", "You run content, advertising and social work from one suite."],
    chooseUs: ["You want to know what to fix next on your own site, not explore a large toolset.", "You want Search Console and GA4 read together, including key events.", "You prefer a short list of priorities in plain English."],
  },
  {
    slug: "ahrefs",
    name: "Ahrefs",
    site: "https://ahrefs.com",
    nav: "Ahrefs vs SEO Signals",
    title: "Ahrefs alternative for Search Console and GA4 priorities | SEO Signals",
    description: "Ahrefs is known for its backlink index and research tools. SEO Signals reads your own Search Console and GA4 data and shows up to three fixes to make first.",
    h1: "An Ahrefs alternative focused on your next fix",
    lead: "Ahrefs is an SEO toolset best known for its backlink index, with keyword research, site audits and rank tracking alongside. SEO Signals doesn't crawl the web. It reads the data Google already has about your site and points to what to fix first.",
    theirJob: "SEO research toolset known for its backlink index",
    theirData: "Ahrefs' own crawler and indexes of backlinks and keywords. Site owners can also verify their site in Ahrefs Webmaster Tools",
    theirOutput: "Research reports, audits and rank tracking",
    theirFeatures: ["Backlink index", "Keyword research database", "Site audit crawler", "Rank tracking", "Competitor research"],
    chooseThem: ["Backlinks are central to your SEO work.", "You research keywords and competitors beyond your own site.", "You want a crawler-based technical audit."],
    chooseUs: ["You want priorities from the Search Console data Google reports for your own site.", "You want GA4 key events in the picture, not just rankings and links.", "You want up to three fixes, explained, rather than many reports to read."],
  },
  {
    slug: "se-ranking",
    name: "SE Ranking",
    site: "https://seranking.com",
    nav: "SE Ranking vs SEO Signals",
    title: "SE Ranking alternative for Search Console and GA4 priorities | SEO Signals",
    description: "SE Ranking is an SEO platform built around rank tracking and audits. SEO Signals reads your Search Console and GA4 data and shows up to three fixes.",
    h1: "An SE Ranking alternative for owners who want priorities",
    lead: "SE Ranking is an SEO platform built around rank tracking, website audits and research, with features for agencies. SEO Signals is narrower: it reads your own Search Console and GA4 data and shows up to three fixes, with the evidence for each.",
    theirJob: "SEO platform for rank tracking, audits and research",
    theirData: "SE Ranking's own tracking, crawling and research databases, plus integrations with Google tools",
    theirOutput: "Rank tracking, audit reports and agency reporting",
    theirFeatures: ["Rank tracking", "Website audit crawler", "Keyword and competitor research", "Backlink monitoring", "Agency and white-label reporting"],
    chooseThem: ["You track many keyword positions over time.", "You need white-label reports for clients.", "You want a crawler-based audit and research tools in one place."],
    chooseUs: ["You want the next fix on your site, not another set of reports.", "You want Search Console and GA4 read together, including key events.", "You want plain-English priorities you can act on yourself."],
  },
].map(a => ({ ...a, ours: OURS }));

export const findAlternative = slug => ALTERNATIVES.find(a => a.slug === slug) || null;
export const pathForAlternative = slug => `/alternatives/${slug}`;

export const OUR_LIMITS = [
  "SEO Signals has no keyword research database, backlink index or rank tracker.",
  "SEO Signals does not crawl your site or other websites.",
  "SEO Signals only sees the Search Console and GA4 properties you connect.",
];
